module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_bruns_sm-293b4e9ae744100b937c50bb1a038cf7.png";